import { render, staticRenderFns } from "./DataSourceAttributesEditing.vue?vue&type=template&id=6066cd38&scoped=true&"
import script from "./DataSourceAttributesEditing.vue?vue&type=script&lang=js&"
export * from "./DataSourceAttributesEditing.vue?vue&type=script&lang=js&"
import style0 from "./DataSourceAttributesEditing.vue?vue&type=style&index=0&id=6066cd38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6066cd38",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VForm,VIcon,VRadio,VRadioGroup,VRow,VTooltip})
